import { SuccessMessage, ErrorMessage } from './ResponseMessage'

export {SuccessMessage, ErrorMessage}
